import PropTypes from 'prop-types';
import React from 'react';
import StyleSheet from 'utilities/StyleSheet';

class HorizontalCard extends React.Component {
  getStyleSheet() {
    return StyleSheet({
      container: Object.assign(
        {
          display: 'flex',
          alignItems: 'center',
        },
        this.props.style
      ),

      children: {
        flex: 1,
        paddingLeft: 16,
        fontSize: 12,
      },

      visualization: {
        width: 98,
        height: 58,
        overflow: 'hidden',
        boxSizing: 'border-box',
      },
    });
  }

  render() {
    const stylesheet = this.getStyleSheet();

    return (
      <div style={{...stylesheet.container, ...this.props.style}}>
        <div style={stylesheet.visualization}>{this.props.visualization}</div>
        <div style={stylesheet.children}>{this.props.children}</div>
      </div>
    );
  }
}

HorizontalCard.defaultProps = {
  style: {},
};

HorizontalCard.propTypes = {
  visualization: PropTypes.object,
  style: PropTypes.object,
  children: PropTypes.node,
};

export default HorizontalCard;
